<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol><h1 class="page__title text-center">{{ title_page }}</h1></CCol>
                <CCol>
                    <CButton
                        color="primary"
                        class="button shadow create-button"
                        @click="$router.push({ name: 'view_integration',query: { view_type:'new', client_id } })"
                    >
                        <span class="button__icon text-white-50">
                            <CIcon :content="$options.icons.cilPlus"/>
                        </span>
                        <span class="button__text">
                            {{ $t("create.webservice") }}
                        </span>
                    </CButton>
                </CCol>
            </CRow>
            <!-- Title page  -->
            
        </CCardHeader>
        <CElementCover v-show="!page_loaded"  :opacity="1" :boundaries="[load_boundaries]">
                <CSpinner style="width: 4rem; height: 4rem;" color="primary" />
    </CElementCover>
        <CCardBody class="main-card-body" v-show="page_loaded">
            <CContainer fluid class="p-0" >
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <CCol
                                    class="d-flex"
                                >
                                    <ButtonBack class="mr-3" />
                                </CCol>
                            </CCardHeader>                          
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.client_workflows.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.client_workflows.fields,
                                        fields:['label']
                                    })"
                                    :items-per-page="tables.client_workflows.rows"
                                    :loading="tables.client_workflows.loading"
                                    hover
                                    pagination
                                >

                                    <template #options="{item}">
                                        <td class="py-2">
                                            {{ item.id }}
                                            <CButton
                                                color="primary"
                                                variant="outline"
                                                square
                                                size="sm"
                                                @click="$router.push({ 
                                                    name: 'view_integration',
                                                    query: { 
                                                        view_type:'edit', 
                                                        client_id, 
                                                        workflow_id: item.workflow_id 
                                                    } 
                                                })"
                                            >
                                                <CIcon class="icon" :content="$options.icons.cilPencil"/>
                                            </CButton>
                                            <CButton
                                                color="danger"
                                                variant="outline"
                                                square
                                                size="sm"
                                                @click="deleteItem(item)"
                                            >
                                                <CIcon class="icon" :content="$options.icons.cilTrash"/>
                                            </CButton>
                                        </td>
                                    </template>
                                </CDataTable>
                                
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.client_workflows.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.client_workflows.page"
                                    :pages="tables.client_workflows.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import TitlePage from "£lement/titlePage";
import FilterDate from "~/components/FilterDate";
import { cilPlus, cilSettings, cilPencil, cilTrash } from '@coreui/icons';
import { mapGetters } from "vuex";
import pageMixin from '~/mixins/page.js';
import ButtonBack from "£lement/ButtonBack";
export default {
    name:"IntegrationPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin ],
    components:{
        TitlePage,
        FilterDate,
        ButtonBack
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash
    },
    data(){
        return{
            tables:{
                client_workflows:{
                    fields: [
                        {
                            key: "workflow_id",
                            label:"#",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                        },
                        {
                            key: "name",
                            label:"name",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "options",
                            label:"options",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                        },
                    ],
                    items:[],
                    order:"asc",
                    rows:10,
                    page:1,
                    total_pages: 0,
                    loading:true
                }
            }
        }
    },
    computed:{
        ...mapGetters({
            from:"filter/from",
            to:"filter/to"
        }), 
        title_page:function(){
            return this.$t("workflow");
        },
        client_id:function(){
            return this.$route.query.client_id;
        }
        
    },
    methods:{
        updatePagination(newValue){
            this.tables.client_workflows.page = newValue;
            this.updateData();
        },
        async updateData() {

           await this.updateTable({
               table_name:"client_workflows", 
               url:'/workflow/client', 
               url_param:this.client_id,
               filter_active:false
           });
           this.page_loaded = true;
           this.$store.dispatch('page/updateLoading', {
                loading: false,
            });

        },        
        async deleteItem(item){

            try {
                await this.deleteData({
                    url:"/workflow",
                    url_param:item.id
                });
                this.updateData();

            } catch (error) {
                return;
            }
            
        }
    },
    mounted(){
        this.updateData();
    }

}
</script>

<style scoped lang="scss">
    .btn-form{
        & .icon{
            background: rgba(0,0,0,.15);
            display: inline-block;
            padding: .375rem .75rem;
        }
        & .text{
            padding: .375rem .75rem;
        }
    }
</style>